"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var CheckboxWidget = /** @class */ (function (_super) {
    __extends(CheckboxWidget, _super);
    function CheckboxWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "wolf-checkbox", children: (0, jsx_runtime_1.jsxs)("label", { className: "checkbox-label", htmlFor: "termsCheckBox", children: [(0, jsx_runtime_1.jsx)("input", { onChange: this.props.callback, type: "checkbox", "aria-label": this.props.label, id: "termsCheckBox", defaultChecked: this.props.defaultValue }), (0, jsx_runtime_1.jsx)("p", { children: this.props.label })] }) }));
    };
    return CheckboxWidget;
}(React.Component));
exports.default = CheckboxWidget;
//# sourceMappingURL=CheckboxWidget.js.map